import Storage from "./storage";
import api from "@/api";

export const locationTaxRates = {
  "Fairfield": 8.375,
  "LA": 11,
  "WA": 10.4
};

let locationCache = {
  rates: null,
  locations: null
};

export function getSelectedOfficeLocation() {
  return Storage.get("selectedLocation") || locationCache.locations?.[0];
}

export function setOfficeLocation(location) {
  Storage.set("selectedLocation", location);
  window.location.reload();
}

export async function getOfficeTaxRate(location) {
  const rates = await getAllOfficeLocationsRates();
  return rates[location] || rates[locationCache.locations?.[0]] || rates[Object.keys(rates)[0]];
}

export async function getAllOfficeLocationsRates() {
  if (locationCache?.rates) return locationCache.rates;
  const res = await api.getLocationRates();
  locationCache.rates = res.data;
  return locationCache.rates;
}

export async function getAllOfficeLocations() {
  if (locationCache?.locations) return locationCache.locations;
  const rates = await getAllOfficeLocationsRates();
  locationCache.locations = Object.keys(rates);
  return locationCache.locations;
}